<div class="tag-icon" [ngClass]="design">
    <ng-content></ng-content>
    <app-icons *ngIf="icon && icon !== ''" [design]="icon"></app-icons>
</div>